module.exports = __webpack_public_path__ + "static/media/theme-logo.a0a9b24e.svg";